<template>
  <div class="floating-menu">
    <a
        v-for="(item, index) in items"
        :key="index"
        :href="item.link"
        target="_blank"
        rel="noopener noreferrer"
        class="floating-image-wrapper"
    >
      <img :src="require(`@/assets/${item.image}`)" class="floating-image" />
    </a>
  </div>
</template>

<script>
export default {
  name: "RightFloatingMenu",

  data() {
    return {
      items: [
        { image: "icon-channel.png",  link: "https://pf.kakao.com/_xfxkgtn" },
        { image: "icon-cafe.png",     link: "https://cafe.naver.com/eduplusireland" },
        { image: "icon-blog.png",     link: "https://blog.naver.com/prestigeuhak_dublin" },
      ],
    };
  },
};
</script>

<style scoped>
/* ===== Desktop / default: right middle ===== */
.floating-menu {
  position: fixed;
  top: 50%;
  right: 10px; /* slight padding from the right */
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  gap: 14px;
  z-index: 9999;
}

.floating-image-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}

.floating-image {
  width: 54px;       /* adjust as needed */
  height: 54px;
  border-radius: 50%;
  object-fit: cover;
  box-shadow: 0 4px 10px rgba(0,0,0,0.15);
  transition: all 0.25s ease;
  cursor: pointer;
  background: white;
}

.floating-image:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 16px rgba(0,0,0,0.25);
}

/* ===== Mobile: bottom bar with icons ===== */
@media (max-width: 600px) {
  .floating-menu {
    top: auto;
    bottom: 0;
    right: 0;
    left: 0;
    transform: none;

    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 24px;


    padding: 13px 0;
    background: #f2f2f2;
  }

  .floating-image {
    width: 44px;
    height: 44px;
  }
}
</style>

<!-- Global (not scoped) to reserve space above the bar on mobile -->
<style>
@media (max-width: 600px) {
  /* Vuetify apps usually wrap content in .v-main.
     If you don't use Vuetify's v-main, replace this selector
     with your main content wrapper (e.g. #app, .app-container, etc.) */
  .v-main {
    padding-bottom: 70px; /* must be >= bar height so content stops above icons */
  }
}
</style>
